export default __webpack_public_path__ + "static/scabtest_hover_mb-51a61d929a15cddcb1000dc3aa814930.png";